import { Component, OnDestroy } from '@angular/core';
import { NavController,ViewController,NavParams,ToastController,AlertController,ModalController,Platform } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { provider } from '../../providers/provider';
import { CartPage } from '../cart/cart';
import { Subject } from 'rxjs';
import { CustomizerProvider } from '../../providers/customizer/customizer';

@Component({
  selector: 'page-productDetail',
  templateUrl: 'productDetail.html'
})
export class productDetailPage implements OnDestroy {
  url: any;
  product: any;
  data: any;
  qty = 1;
  max: any;
  cont = 0;
  tot = 0;
  variants = [];
  ingredients = [];
  width: any;
  height: any;
  private _onDestroy = new Subject();

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public translateService: TranslateService,
              public storage: Storage,
              public viewCtrl: ViewController,
              public toastCtrl: ToastController,
              public alertCtrl: AlertController,
              public modalCtrl: ModalController,
              public provider: provider,
              public customizer: CustomizerProvider,
              public platform: Platform) {

    let varIngrGruppo=[];
    let varIngr=[];

    this.url = provider.getUrl();

    this.product = navParams.get('product');
    this.data = provider.getMenu();
    
    platform.ready().then((readySource) => {
      this.height = platform.height();
      this.width = platform.width();
    });

    //calcolo del massimo delle varianti selezionabili
    if(this.product.content.extraProps.prodMaxVar) {
      this.max = this.product.content.extraProps.prodMaxVar;
    }
    else {
      if(this.product.parent) {
        for(let i=0; i<this.data.menu.righe.length; i++) {
          if(this.data.menu.righe[i]._id == this.product.parent) {
            if(this.data.menu.righe[i].content.extraProps.prodMaxVar) {
              this.max = this.data.menu.righe[i].content.extraProps.prodMaxVar
            }
            else {
              this.max = this.data.settings.prodMaxVar;
            }
          }
        }
      }
      else {
        this.max = this.data.settings.prodMaxVar;
      }
    }

    //varianti/ingredienti del gruppo
    for(let i=0; i<this.data.menu.righe.length; i++) {
      if(this.data.menu.righe[i]._id == this.product.parent) {
        for(let j=0; j<this.data.menu.righe[i].content.varIngr.length; j++) {
          varIngrGruppo.push(this.data.menu.righe[i].content.varIngr[j]);
        }
      }
    }

    //recupero degli oggetti dalla libreria
    for(let j=0; j<varIngrGruppo.length; j++) {
      for(let i=0; i<this.data.lib.length; i++) {
        if(this.data.lib[i]._id == varIngrGruppo[j]) {
          varIngr.push(JSON.parse(JSON.stringify(this.data.lib[i])));
        }
      }
    }
    for(let j=0; j<this.product.content.varIngr.length; j++) {
      for(let i=0; i<this.data.lib.length; i++) {
        if(this.data.lib[i]._id == this.product.content.varIngr[j]) {
          varIngr.push(JSON.parse(JSON.stringify(this.data.lib[i])));
        }
      }
    }

    let favoriteVariants = []
    if(this.data.settings.hideIngredients) {
      for(let i=0; i<varIngr.length; i++) {
        varIngr[i].quantita = 0;
        if(varIngr[i].isFavorite) {
          favoriteVariants.push(JSON.parse(JSON.stringify(varIngr[i])))
        }
        else {
          this.variants.push(JSON.parse(JSON.stringify(varIngr[i])));
        }
      }
    } else {
      //rimozione dei duplicati
      let obj = [];
      varIngr.forEach((value, key) => {
        let exists = false;
        obj.forEach((value2, key) => {
          if(value._id == value2._id) exists = true;
        })
        if(!exists) obj.push(value);
      })
      //inserimento della proprietà "quantità" per ogni variante/ingrediente e divisione in ingredienti/varianti
      for(let i=0; i<obj.length; i++) {
        obj[i].quantita = 0;
        if(!obj[i].extraProps.isIngrediente) {
          if(obj[i].isFavorite) 
            favoriteVariants.push(JSON.parse(JSON.stringify(obj[i])))
          else
            this.variants.push(JSON.parse(JSON.stringify(obj[i])));
        }
        else {
          this.ingredients.push(JSON.parse(JSON.stringify(obj[i])));
        }
      }
    }
    for(let i=0; i<favoriteVariants.length; i++) {
      this.variants.unshift(favoriteVariants[i])
    }
    

  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  getImgAllergene(img) {
    return 'assets/ALLERGENI/' + img + '.png';
  }

  getImage(prod) {
    let imageType = this.data.settings.imageType;

    if(prod.extraProps.imageType) {
      imageType = prod.extraProps.imageType;
    }
    
    switch(imageType) {
      case 'S':
        return this.url + prod.img + '?h=' + (this.height/4);
      case 'M':
        return this.url + prod.img + '?h=' + (this.height/3);
      case 'L':
        return this.url + prod.img + '?h=' + (this.height/2);
    }
  }

  ionViewDidEnter() {
    this.tot = this.provider.showTotal();
  }
  
  cart() {
    this.navCtrl.push(CartPage);
  }

  //allergie
  showAllergy(allergy) {
    let text,contain,allergyText;

    this.translateService.get('CONTIENE').takeUntil(this._onDestroy).subscribe(value => { contain = value });
    this.translateService.get(allergy).takeUntil(this._onDestroy).subscribe(value => { allergyText = value });

    text = '<img src="assets/ALLERGENI/' + allergy + '.png"><br><h2>' + contain + '<br><b>' + allergyText + '</b></h2>';

    let alert = this.alertCtrl.create({
      subTitle: text,
      buttons: ['OK']
    });
    alert.present();
  }

  // aggiungere o rimuovere quantità del prodotto
  addQty() {
    if(this.product.content.disponibilita != null) {
      if(this.qty < parseInt(this.product.content.disponibilita))
        this.qty++;
      else {
        let alert = this.alertCtrl.create({
          title: 'Errore, limite raggiunto!',
          subTitle: 'Ci dispiace ma questo articolo è a disponibilità limitata. Non puoi ordinare più di ' + (this.product.content.disponibilita == 1 ? "un articolo" : this.product.content.disponibilita + " articoli"),
          buttons: ['OK']
        });
        alert.present();
      }
    } else
      this.qty++;
  }
  removeQty() {
    if(this.qty > 1) {
      this.qty--;
    }
  }

  //aggiungere o togliere quantità alla variante
  increaseQty(item) {
    if(item.quantita < 0) {
      item.quantita++;
      this.cont--;
    }
    else {
      if(this.cont != this.max) {
        item.quantita++;
        this.cont++;
      }
      else {
        this.alertMaxVariant();
      }
    }
  }
  decreaseQty(item) {
    if(item.quantita <= 0) {
      if(this.cont != this.max) {
        item.quantita--;
        this.cont++;
      }
      else {
        this.alertMaxVariant();
      }
    }
    else {
      item.quantita--;
      this.cont--;
    }
  }

  alertMaxVariant() {
    let alert = this.alertCtrl.create({
      title: 'Errore, limite raggiunto!',
      subTitle: 'Non puoi aggiungere altre varianti!',
      buttons: ['OK']
    });
    alert.present();
  }

  //aggiungere al carrello il prodotto
  addToCart(prod) {
    let varianti = [];
    let varPerc = [];
    let ingPerc = [];
    let cart = this.provider.getCart();
    
    let toast = this.toastCtrl.create({
      message: 'Prodotto aggiunto al carrello!',
      duration: 3000
    });
    
    //console.log(prod)

    for(let i=0; i<this.ingredients.length; i++) {
      if(this.ingredients[i].quantita != 0) {
        if(this.ingredients[i].prezzo.tipo == 1) {
          varianti.push(this.ingredients[i]);
        }
        else if(this.ingredients[i].prezzo.tipo == 2) {
          ingPerc.push(this.ingredients[i]);
        }
      }
    }
    
    for(let i=0; i<this.variants.length; i++) {
      if(this.variants[i].quantita != 0) {
        if(this.variants[i].prezzo.tipo == 1) {
          varianti.push(this.variants[i]);
        }
        else if(this.variants[i].prezzo.tipo == 2) {
          varPerc.push(this.variants[i]);
        }
      }
    }
    for(let i=0;i<varPerc.length;i++) {
      varianti.push(varPerc[i]);
    }

    var item = {
      "quantita": this.qty,
      "varIngr": varianti,
      "prodotto": prod,
      "max": this.max,
      "cont": this.cont,
      "disponibilita": parseInt(this.product.content.disponibilita),
      "id": Math.random().toString(36).slice(2)
    }

    let controlloAccorpamento = false;
    let specialProduct = null;
    let qty = item.quantita;
    for(let i=0; i<cart.length; i++) {
      if(cart[i].prodotto._id == prod._id && cart[i].prodotto.content.disponibilita != null) {
        qty = qty + cart[i].quantita;
      }
      if (cart[i].prodotto.content.trendCustomProperties && prod.content.trendCustomProperties) {
        if (JSON.stringify(cart[i].prodotto.content.trendCustomProperties) == JSON.stringify(prod.content.trendCustomProperties))
          specialProduct = true;
        else 
          specialProduct = false;
      } else if(cart[i].prodotto.content.trendCustomProperties)
        specialProduct = false;
      else if(prod.content.trendCustomProperties)
        specialProduct = false;
    }
    if (qty > item.disponibilita) {
      controlloAccorpamento = true;
    }

    if(specialProduct) {
      this.provider.addToCart(item);
      toast.present();
      this.navCtrl.pop();
      return;
    } else if(specialProduct == false){
      let alert = this.alertCtrl.create({
        title: 'Errore!',
        subTitle: 'Non puoi abbinare gli articoli che hai nel carrello a questo articolo.',
        buttons: ['OK']
      });
      alert.present();
      return;
    }

    if(!controlloAccorpamento) {
      this.provider.addToCart(item);
      toast.present();
      this.navCtrl.pop();
    } else {
      let alert = this.alertCtrl.create({
        title: 'Errore, limite raggiunto!',
        subTitle: 'Ci dispiace ma questo articolo, a disponibilità limitata, è già nel tuo carrello. Non puoi ordinare complessivamente più di ' + (this.product.content.disponibilita == 1 ? "un articolo" : this.product.content.disponibilita + " articoli"),
        buttons: ['OK']
      });
      alert.present();
    }

  }

  readMore(descr) {
    let text;

    text = this.provider.renderDescrEstesa(descr);

    let alert = this.alertCtrl.create({
      title: 'Informazioni',
      message: text,
      buttons: ['OK']
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/productDetail/productDetail.ts